import {LaboratoryShowcasePageWrapperBox} from "./boxes/page-wrapper/laboratory-showcase-page-wrapper.box";
import {ILaboratoryShowcase} from "./laboratory-showcase.inteface";
import {GeoLocationBrowserApiTestComponent} from "./showcases/geo-location-browser-api-test.component";
import {ToasterShowcase} from "./showcases/toaster-showcase.component";
import {GamblingSessionSetupDialogShowcase} from "./showcases/gambling-session-setup-dialog-showcase.component";
import {OnboardingTourShowcase} from "./showcases/onboarding-tour-showcase.component";
import {BurnoutAnimationShowcase} from "./showcases/burnout-animation-showcase.component";
import {PixiSpineShowcase} from "./showcases/pixi-spine-showcase.component";
import {ThemeSwitcher} from "./theme-switcher.component";
import {ButtonsShowcase} from "./showcases/buttons-showcase.component";
import {TypographyColorAndPresetShowcase} from "./showcases/typography-color-and-preset-showcase.component";
import {PopoupsShowcase} from "./showcases/popups-showcase.component";
import {IconsShowcase} from "./showcases/icons-showcase.component";
import {MediaQueryShowcase} from "./showcases/media-query-showcase.component";
import {ClientHintsShowcase} from "./showcases/client-hints-showcase.component";
import {LaboratoryShowcaseContainerComponent} from "./laboratory-showcase-container.component";
import {SimpleMessageDialogShowcase} from "./showcases/simple-message-dialog-showcase.component";

const SHOWCASES: ILaboratoryShowcase[] = [
    {
        name: "geoLocation",
        title: "Geo Location Browser Api Test",
        renderer: <GeoLocationBrowserApiTestComponent />
    }, {
        name: "toaster",
        title: "Toasters",
        renderer: <ToasterShowcase />
    }, {
        name: "gamblingSession",
        title: "Gambling Session Setup Dialog",
        renderer: <GamblingSessionSetupDialogShowcase />
    }, {
        name: "onboardingTour",
        title: "Onboarding Tour",
        renderer: <OnboardingTourShowcase />
    }, {
        name: "burnoutAnimation",
        title: "Burnout Animation",
        renderer: <BurnoutAnimationShowcase />
    }, {
        name: "pixiSpine",
        title: "Pixi Spine",
        renderer: <PixiSpineShowcase />
    }, {
        name: "buttons",
        title: "Buttons",
        renderer: <ThemeSwitcher><ButtonsShowcase /></ThemeSwitcher>
    }, {
        name: "typographyColorAndPreset",
        title: "Typography Color And Preset",
        renderer: <ThemeSwitcher><TypographyColorAndPresetShowcase /></ThemeSwitcher>,
        showcaseDisabled: true
    }, {
        name: "popups",
        title: "Popups",
        renderer: <PopoupsShowcase />
    },{
        name: "simpleDialogs",
        title: "Simple dialogs",
        renderer: <SimpleMessageDialogShowcase />
    },
    {
        name: "icons",
        title: "Icons",
        renderer: <IconsShowcase />
    }, {
        name: "mediaQuery",
        title: "Media Query",
        renderer: <MediaQueryShowcase />
    }, {
        name: "clientHints",
        title: "Client Hints",
        renderer: <ClientHintsShowcase />
    }
];

export function LaboratoryShowcase() {
    return (
        <LaboratoryShowcasePageWrapperBox>
            {SHOWCASES.map(showcase => LaboratoryShowcaseContainerComponent(showcase))}
        </LaboratoryShowcasePageWrapperBox>
    );
}
